<script lang="ts">
  export default {
    name: 'YearFilter'
  };
</script>

<script setup lang="ts">
import FilterButton from './FilterButton.vue';
import { ref, computed, watch } from 'vue';

const COMPARE_TOOLTIP = "Select two or more years to compare how carrier's rates have changed over time";

const props = defineProps<{
  years: number[];
  modelValue: number[];
}>();

const emit = defineEmits<{
  (e: 'input', value: number[]): void;
  (e: 'update:modelValue', value: number[]): void;
  (e: 'compare'): void;
  (e: 'aggregate'): void;
}>();

const selected = ref<number[]>([]);

const title = computed(() => {
  if (selected.value.length === 1) {
    return selected.value[0].toString();
  }
  return 'Year';
});

function clear() {
  selected.value = [];
}

function aggregate() {
  emit('update:modelValue', selected.value);
  emit('aggregate');
}

function compare() {
  emit('update:modelValue', selected.value);
  emit('compare');
}

function selectAll() {
  selected.value = props.years;
}

watch(() => props.modelValue, (newValue) => {
  selected.value = newValue;
}, { immediate: true });

</script>

<template>
  <FilterButton :title="title" :active="selected.length > 0" data-testid="carrier-group-filter">
    <template #menu="{ close }">
      <div class="tw:py-4 tw:pt-0">
        <h4 class="tw:mx-4 tw:mt-4 tw:mb-1">Years</h4>
        <div class="tw:flex tw:flex-col tw:mx-4 tw:mb-4 tw:pl-2">
          <label v-for="year in props.years" :key="year"
                 class="tw:items-center tw:py-1 tw:cursor-pointer tw:select-none">
            <input type="checkbox" v-model="selected" :value="year" data-testid="filter-item-carrier-group-checkbox" />
            <span class="tw:mx-2">{{ year }}</span>
          </label>
        </div>
        <div class="tw:px-4 tw:flex tw:justify-between tw:gap-1">
          <v-btn size="small" variant="outlined" @click="clear" data-testid="filter-carrier-group-clear">Clear</v-btn>

          <v-btn class="" variant="flat" size="small" color="secondary"
                 @click="selectAll" data-testid="filter-carrier-group-select-all">Select All
          </v-btn>

          <v-btn size="small" variant="flat" color="primary" @click="aggregate(); close()"
                 data-testid="filter-carrier-group-apply">
            Aggregate
          </v-btn>

          <div class="tw:tooltip tw:tooltip-top tw:flex tw:items-center" :data-tip="COMPARE_TOOLTIP">
            <v-btn size="small" variant="flat" color="primary" :disabled="selected.length < 2" @click="compare(); close()"
              data-testid="filter-carrier-group-apply">
              Compare
            </v-btn>
          </div>
        </div>
      </div>
    </template>
  </FilterButton>
</template>
